import { registerLocaleData } from '@angular/common';
import localePt from '@angular/common/locales/pt';
import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

registerLocaleData(localePt, 'pt');

if (environment.production) {
  enableProdMode();
}

async function bootstrap() {
  try {
    await platformBrowserDynamic().bootstrapModule(AppModule);
  } catch (err) {
    console.error(err);
  }
}

if (document.readyState === 'complete') {
  bootstrap();
} else {
  document.addEventListener('DOMContentLoaded', () => bootstrap());
}
